// 10 head-to-head comparison pages, data-driven from vpns.js
export const COMPARISONS = [
  {
    slug: "nordvpn-vs-surfshark",
    a: "nordvpn",
    b: "surfshark",
    verdict:
      "NordVPN wins on speed, server coverage, and privacy audit record. Surfshark wins on unlimited connections and price. For most users NordVPN is the better choice; for big households Surfshark is excellent.",
    winner: "nordvpn",
  },
  {
    slug: "nordvpn-vs-purevpn",
    a: "nordvpn",
    b: "purevpn",
    verdict:
      "NordVPN beats PureVPN on speed, streaming reliability, and privacy credentials. PureVPN counters with a marginally larger server count and the lowest price of our five picks. Unless budget is decisive, NordVPN is the stronger VPN.",
    winner: "nordvpn",
  },
  {
    slug: "nordvpn-vs-veepn",
    a: "nordvpn",
    b: "veepn",
    verdict:
      "This isn't close: NordVPN is faster, streams more reliably, and has a twice-audited no-log policy where VeePN's is unverified. VeePN's case rests on unlimited connections and simplicity. NordVPN wins comfortably.",
    winner: "nordvpn",
  },
  {
    slug: "nordvpn-vs-adguard-vpn",
    a: "nordvpn",
    b: "adguard-vpn",
    verdict:
      "NordVPN outperforms AdGuard VPN on speed, streaming, server network (6,400+ vs 500+), and audit record. AdGuard VPN's DNS-level ad blocking is genuinely unique — but NordVPN's Threat Protection covers similar ground while winning everywhere else.",
    winner: "nordvpn",
  },
  {
    slug: "surfshark-vs-purevpn",
    a: "surfshark",
    b: "purevpn",
    verdict:
      "Surfshark edges PureVPN on speed (93% vs 91%), streaming consistency, and unlimited connections. PureVPN counters with a larger server network and a lower headline price. For most users, Surfshark is the better all-rounder.",
    winner: "surfshark",
  },
  {
    slug: "surfshark-vs-veepn",
    a: "surfshark",
    b: "veepn",
    verdict:
      "Both offer unlimited connections, but Surfshark is faster, streams more reliably, and has a Deloitte-audited no-log policy where VeePN's is unverified. At $2.29 vs $2.50, Surfshark is also cheaper. Clear win for Surfshark.",
    winner: "surfshark",
  },
  {
    slug: "surfshark-vs-adguard-vpn",
    a: "surfshark",
    b: "adguard-vpn",
    verdict:
      "Surfshark wins on speed, streaming, server network, and connection count (unlimited vs 5). AdGuard VPN's integrated DNS ad blocking is its trump card — but Surfshark's CleanWeb offers similar functionality. Surfshark takes it.",
    winner: "surfshark",
  },
  {
    slug: "purevpn-vs-veepn",
    a: "purevpn",
    b: "veepn",
    verdict:
      "PureVPN is faster (91% vs 85%), has a far larger network (6,500+ vs 2,500+ servers), a KPMG-audited no-log policy, and a lower price. VeePN counters with unlimited connections and friendlier apps. PureVPN wins on substance.",
    winner: "purevpn",
  },
  {
    slug: "purevpn-vs-adguard-vpn",
    a: "purevpn",
    b: "adguard-vpn",
    verdict:
      "PureVPN offers thirteen times the servers, twice the connections, better speeds, and an audited no-log policy at a lower price. AdGuard VPN's answer is its unique ad-blocking stack and free tier. For a pure VPN, PureVPN wins.",
    winner: "purevpn",
  },
  {
    slug: "veepn-vs-adguard-vpn",
    a: "veepn",
    b: "adguard-vpn",
    verdict:
      "The battle of our #4 and #5. VeePN wins on connections (unlimited vs 5), server network, and speed. AdGuard VPN wins on privacy pedigree and its integrated ad blocking. For most users VeePN is more practical; privacy-stack fans should pick AdGuard.",
    winner: "veepn",
  },
];

export const getComparison = (slug) => COMPARISONS.find((c) => c.slug === slug);
